<app-header-latest></app-header-latest>
<div class="press-hero">
  <div class="container-wrapper">
    <div class="section-eyebrow" style="color:rgba(255,255,255,0.5);">📰 MEDIA &amp; PRESS</div>
    <h1>NeoHRMZ Press Kit</h1>
    <p>Logos, screenshots, boilerplate copy, company facts, and everything journalists and content creators need — ready to download.</p>
    <div style="display:flex;gap:16px;justify-content:center;flex-wrap:wrap;">
      <a href="#" class="btn btn-white">Download Full Press Kit (.zip)</a>
      <a href="#press-contact" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.25);">Contact Press Team</a>
    </div>
  </div>
</div>

<!-- DOWNLOADS -->
<section class="press-downloads">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⬇️ Quick Downloads</span>
      <h2 class="sec-h2">Get What<br><span class="gradient-text">You Need Fast</span></h2>
    </div>
    <div class="downloads-grid">
      <div class="download-card">
        <div class="download-card__icon">🖼️</div>
        <div class="download-card__title">Logo Pack</div>
        <div class="download-card__desc">Full color, white, black, and monochrome variants in SVG, PNG, and EPS.</div>
        <a href="#" class="btn btn-outline" style="font-size:12px;">Download <span class="download-card__badge">SVG · PNG · EPS</span></a>
      </div>
      <div class="download-card">
        <div class="download-card__icon">📸</div>
        <div class="download-card__title">Product Screenshots</div>
        <div class="download-card__desc">High-resolution screenshots of key product features — dashboard, payroll, and AI assistant.</div>
        <a href="#" class="btn btn-outline" style="font-size:12px;">Download <span class="download-card__badge">PNG · WebP</span></a>
      </div>
      <div class="download-card">
        <div class="download-card__icon">🎨</div>
        <div class="download-card__title">Brand Guidelines</div>
        <div class="download-card__desc">Color palette, typography, spacing rules, and do/don't usage guide in PDF format.</div>
        <a href="#" class="btn btn-outline" style="font-size:12px;">Download <span class="download-card__badge">PDF · 4.2MB</span></a>
      </div>
      <div class="download-card">
        <div class="download-card__icon">📄</div>
        <div class="download-card__title">Boilerplate &amp; Bios</div>
        <div class="download-card__desc">Company overview paragraph, founder bios, and product one-liners in editable formats.</div>
        <a href="#" class="btn btn-outline" style="font-size:12px;">Download <span class="download-card__badge">DOCX · TXT</span></a>
      </div>
    </div>
  </div>
</section>

<!-- BRAND ASSETS -->
<section class="brand-assets-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🎨 Brand Assets</span>
      <h2 class="sec-h2">Logo Variants<br><span class="gradient-text">&amp; Usage</span></h2>
    </div>
    <div class="assets-grid">
      <div class="asset-card">
        <div class="asset-card__preview asset-card__preview--color">H</div>
        <div class="asset-card__body">
          <div class="asset-card__name">Primary Logo — Color</div>
          <div class="asset-card__formats">SVG · PNG · EPS</div>
        </div>
      </div>
      <div class="asset-card">
        <div class="asset-card__preview asset-card__preview--dark" style="font-size:40px;font-weight:900;color:#fff;">H</div>
        <div class="asset-card__body">
          <div class="asset-card__name">Logo on Dark Background</div>
          <div class="asset-card__formats">SVG · PNG</div>
        </div>
      </div>
      <div class="asset-card">
        <div class="asset-card__preview asset-card__preview--light" style="font-size:40px;font-weight:900;color:#5b21b6;">H</div>
        <div class="asset-card__body">
          <div class="asset-card__name">Logo on Light Background</div>
          <div class="asset-card__formats">SVG · PNG</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- COMPANY FACTS -->
<section class="facts-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📊 Company at a Glance</span>
      <h2 class="sec-h2">Key Facts &amp;<br><span class="gradient-text">Figures</span></h2>
    </div>
    <div class="facts-grid">
      <div class="fact-card"><div class="fact-card__num">12,000+</div><div class="fact-card__label">Companies served worldwide</div></div>
      <div class="fact-card"><div class="fact-card__num">2.4M+</div><div class="fact-card__label">Employees managed on platform</div></div>
      <div class="fact-card"><div class="fact-card__num">120+</div><div class="fact-card__label">Countries supported for payroll</div></div>
      <div class="fact-card"><div class="fact-card__num">2019</div><div class="fact-card__label">Founded in Bangalore, India</div></div>
    </div>
  </div>
</section>

<!-- COVERAGE -->
<section class="coverage-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📰 In the News</span>
      <h2 class="sec-h2">Media<br><span class="gradient-text">Coverage</span></h2>
    </div>
    <div class="coverage-grid">
      <div class="coverage-card">
        <div class="coverage-card__outlet">TechCrunch</div>
        <div class="coverage-card__quote">"NeoHRMZ is redefining what modern HRMS software looks like — fast, developer-friendly, and genuinely delightful."</div>
        <div class="coverage-card__date">May 2025</div>
      </div>
      <div class="coverage-card">
        <div class="coverage-card__outlet">Forbes India</div>
        <div class="coverage-card__quote">"One of the most ambitious HR platforms to come out of India's SaaS ecosystem — and one of the fastest-growing."</div>
        <div class="coverage-card__date">March 2025</div>
      </div>
      <div class="coverage-card">
        <div class="coverage-card__outlet">HR Technology News</div>
        <div class="coverage-card__quote">"The AI features in NeoHRMZ aren't gimmicks — they're deeply integrated into workflows and genuinely save hours per week."</div>
        <div class="coverage-card__date">January 2025</div>
      </div>
    </div>
  </div>
</section>

<!-- PRESS CONTACT -->
<section class="press-contact-section" id="press-contact">
  <div class="container-wrapper">
    <h2 class="press-contact-section__h2">Get in Touch<br>with Our Press Team</h2>
    <p class="press-contact-section__p">For interview requests, fact-checking, or embargo access, reach us directly.</p>
    <div class="press-contact-section__email">press@NeoHRMZ.io</div>
    <div class="press-contact-section__note">We typically respond within 4 business hours. For urgent requests, please mark your subject line URGENT.</div>
  </div>
</section>

<app-peopleflow-footer></app-peopleflow-footer>
